import { Box } from "@mui/material";
import {
  createSearchParams,
  Link as RouterLink,
  useNavigate,
} from "react-router-dom";
import Chip from "src/components/common/Chip";
import { Button } from "src/components/common/FormComponents";
import { CHIP_STATUS, PROJECT_STATUS } from "src/constants/common";
import { path } from "src/constants/path";
import defaultStyles from "../styles";
import { useAppSelector } from "src/redux/store";

export const RenderChip = (params) => {
  return (
    <Chip
      label={PROJECT_STATUS[params.row.chipTitle]}
      status={CHIP_STATUS[params.row.status]}
      description={params.row.remarks}
      showTooltip={PROJECT_STATUS[params.row.chipTitle] === "Rejected"}
    />
  );
};

export const RenderButton = (params) => {
  return (
    <>
      <Box
        component={RouterLink}
        to={`${"/activity/details"}?${createSearchParams({
          projectId: params.id,
          projectType: params.row.data.projectType,
        })}`}
        sx={{ ...defaultStyles.renderButtonText2 }}
      >{`${params?.row?.registrationNo}`}</Box>
    </>
  );
};

export const RenderDemandDraft = (params) => {
  const navigate = useNavigate();
  return (
    <>
      {params?.row?.status === "PAYMENT_PENDING" ? (
        <Box
          component={RouterLink}
          to={`${path.demandNote}?${createSearchParams({
            id: params.id,
          })}`}
          sx={{ ...defaultStyles.renderButtonText2 }}
        >{`${"Make Payment"}`}</Box>
      ) : (
        <Box sx={{ color: "red" }}>----</Box>
      )}
    </>
  );
};

export const RenderView = (params) => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.root.user);
  return (
    <>
      <Box
        component={RouterLink}
        to={`${"/view-details"}?${createSearchParams({
          id: params.row.id,
        })}`}
        sx={{ ...defaultStyles.renderButtonText3 }}
      >
        {`${params?.row?.id}`}
      </Box>
    </>
  );
};

export const RenderUploadDPRButton = (params) => {
  return (
    <Box
      component={RouterLink}
      to={`${path.dprForm}?${createSearchParams({
        landOwnershipEpid: params.row.id,
      })}`}
      sx={{ ...defaultStyles.renderButtonText3 }}
    >
      Upload DPR
    </Box>
  );
};
export const RenderUploadSiteVisitButton = (params) => {
  const user = useAppSelector((state) => state.root.user);

  const isAllowed =
    params.row.status === "PROVISIONAL_SELECTED" &&
    user?.data?.role === "Entity/ Green Credit Applicant";

  if (!isAllowed) {
    return <Box sx={{ color: "red" }}>----</Box>;
  }

  return (
    <Box
      component={RouterLink}
      to={`/site-visit?${createSearchParams({
        id: params.row.id,
      })}`}
      sx={defaultStyles.renderButtonText3}
    >
      Upload Site Visit
    </Box>
  );
};
